/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".dummy{background:#00f}"}]);
/* tslint:enable */